import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import settings from '@/settings'
NProgress.configure({ showSpinner: false })

const getPageTitle = (key: string) => `${settings.title}`

router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start()
  next()
  // if (UserModule.isLogin) {
  //   if (UserModule.roles.length === 0) {
  //     try {
  //       await UserModule.GetUserInfo()
  //       const roles = UserModule.roles
  //       PermissionModule.GenerateRoutes(roles)
  //       router.addRoutes(PermissionModule.dynamicRoutes)
  //       await UserModule.GetMessageIsRead()
  //       next({ ...to, replace: true })
  //     } catch (err) {
  //       next(`/login?redirect=${to.path}`)
  //       NProgress.done()
  //     }
  //   } else {
  //     next()
  //   }
  // } else {
  //   next()
  // }
})

router.afterEach((to: Route) => {
  NProgress.done()
  document.title = getPageTitle(to.meta.title)
})
